export default __webpack_public_path__ + "static/media/human-icon.564de5a8.svg";